import React, { useState, useEffect, useRef } from "react";
import { useParams,useNavigate } from 'react-router-dom';
import {  toast } from "react-toastify";
import CryptoJS from "crypto-js";
import "./Scheme.css";
import Input from "./Input";
import Select from "./Select";
import green_check from "./../../../images/svg/green-check.svg";
import Modal from "./Modal";
import { getAllDistrictList, getAllSportList } from "../../../services/commonApiService/CommonApiService";
import { uploadSchemeDocument, applyForScheme, getUserDetails } from "../../../services/schemeApiService/SchemeApiService";
import DatePickerField from "./DatePickerField";
import ViewDocument from "./ViewDocument";

const alreadyUploadedDocUrl= process.env.REACT_APP_UPLOADED_DOC_URL;

const MAX_PHOTO_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_DOC_SIZE = 2 * 1024 * 1024; // 2MB

const SchemeForm = () => {

  const navigate = useNavigate();

  const { encryptedSchemeId } = useParams();

  const inputRefs = useRef({}); // Ref object
      
  let secretKey = process.env.REACT_APP_SECRET_KEY ;
  let bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedSchemeId), secretKey);
  let schemeId = bytes.toString(CryptoJS.enc.Utf8);

  const [formData, setFormData] = useState({"gender":"","district":"","sport":"","medal":"","competition":"","sport_category_senior_junior":"","sport_category_team_ind":"","contact":"","aadhar":"","pincode":"","player_bank_account_number":"","number_of_players":null,"coach_pincode":"","coach_contact":"","coach_bank_account_number":"","second_coach_pincode":"","second_coach_contact":"","second_coach_bank_account_number":"","third_coach_pincode":"","third_coach_contact":"","third_coach_bank_account_number":"","rec_dep_mobile":""});
  const [errors, setErrors] = useState({});
  const [isDeclared, setIsDeclared] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [applicationId, setApplicationId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [readOnlyFields, setReadOnlyFields] = useState([]);
  const [fetchedAadhaar, setFetchedAadhaar] = useState(null);
  const [fetchedProfile, setFetchedProfile] = useState(null);
  const [noOfCoaches, setNoOfCoaches] = useState(0);
  const [coach1, setCoach1] = useState(false);
  const [coach2, setCoach2] = useState(false);
  const [coach3, setCoach3] = useState(false);

  // const [profilePhoto, setProfilePhoto] = useState(null);

  const [competetionTypes, setCompetetionTypes]=useState([
    { id: 1, label: 'Olympic Games' },
    { id: 2, label: 'World cup/Championship' },
    { id: 3, label: 'Asian games' },
    { id: 4, label: 'Commonwealth games' },
    { id: 5, label: 'Asian Championship' },
    { id: 6, label: 'Commonwealth Championship' },
    { id: 7, label: 'South Asian Games' },
    { id: 8, label: 'National Games' },
    { id: 9, label: 'World university games/World School Games, World Police Games' },
    { id: 10, label: 'International Veteran Master Championship' },
    { id: 11, label: 'National championship, National School Games, Khelo India Games, All India Rural Games, National Women Games' },
    { id: 12, label: 'All India University Championship/Tournament, Khelo India University Games' },
    { id: 13, label: 'National Civil Services Competition, All India Police Tournament' },
    { id: 14, label: 'National Veteran Master championship' },
  ]);
  
  const [medalList, setMedalList]=useState([
    { id: 1, label: 'Gold' },
    { id: 2, label: 'Silver' },
    { id: 3, label: 'Bronze' },
    { id: 4, label: 'Participation' },
  ]);
  const [genderList, setGenderList]=useState([
    { id: "M", label: 'Male' },
    { id: "F", label: 'Female' },
    { id: "O", label: 'Other' }
  ]);

  const [districtList, setDistrictList]=useState([
    // { id: 1, label: 'Almora' },
    // { id: 2, label: 'Dehradun' }
  ]);

  const [sportList, setSportList]=useState([
    // { id: 1, label: 'Badminton' },
    // { id: 2, label: 'Kho-kho' }
  ]);

  const [sportCategoryList, setSportCategoryList]=useState([
    { id: 1, label: 'Senior' },
    { id: 2, label: 'Junior/youth' },
    { id: 3, label: 'Sub-junior' },
    { id: 4, label: 'Other' }
  ]);

  const [sportCategoryTeamIndList, setSportCategoryTeamIndList]=useState([
    { id: 1, label: 'Individual' },
    { id: 2, label: 'Team' }
  ]);

    const fetchDistricts = async () => {
      try {
        const response = await getAllDistrictList(4016);

        let transformedData = response.data.map(item => ({
          id: item.id,
          label: item.name
        }));

        setDistrictList(transformedData);

      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    const fetchSports = async () => {
      try {
        const response = await getAllSportList();
        // console.log(response.data);

        let transformedData = response.data.data.map(item => ({
          id: item.sport_id,
          label: item.sport_name
        }));

        setSportList(transformedData);

      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    // const formatDate = (dateStr) => {
    //   const [year, month, day] = dateStr.split('-');
    //   return `${day}-${month}-${year}`;
    // };

    const fetchUserDetails = async () => {
      try {
        const response = await getUserDetails();
        // console.log(response.data.data);
        let userdetails=response.data.data;
        setFormData({
          ...formData,
          "name":`${userdetails.first_name}${userdetails.middle_name?" "+userdetails.middle_name:""}${userdetails.last_name?" "+userdetails.last_name:""}`,
          "father_name":userdetails.father_name,
          "dob":userdetails.dob,
          "gender":userdetails.gender,
          "email":userdetails.email,
          "aadhar":userdetails.identity_card,
          "contact":userdetails.mobile,
          "address":userdetails.address,
          "district":userdetails.city,
          "pincode":userdetails.pincode,
          "player_bank_account_number":userdetails.bank_account_number,
          "player_ifsc_code":userdetails.ifsc_code,
          "player_bank_name":userdetails.bank_name,
          "player_bank_branch":userdetails.branch_name,
          });

          let readonly=[];

          if(userdetails.identity_card!=null){
            // console.log("identity_card",userdetails.identity_card);
            readonly.push("aadhar");
          }
          if(userdetails.city!=null){
            // console.log("district",userdetails.city);
            readonly.push("district");
          }
          if(userdetails.bank_account_number!=null){
            // console.log("district",userdetails.city);
            readonly.push("player_bank_account_number");
          }
          if(userdetails.ifsc_code!=null){
            // console.log("district",userdetails.city);
            readonly.push("player_ifsc_code");
          }
          if(userdetails.branch_name!=null){
            // console.log("district",userdetails.city);
            readonly.push("player_bank_name");
          }
          if(userdetails.branch_name!=null){
            // console.log("district",userdetails.city);
            readonly.push("player_bank_branch");
          }

          setReadOnlyFields([...readOnlyFields,...readonly]);

          const documents = userdetails.documents || [];

          // console.log("documents",documents);

          const getDocumentPath = (type) => {
            const doc = documents.find(d => d.doc_name === type);
            return doc ? doc.doc_file : "";
          };

          if(getDocumentPath("profile_image")){
            setFetchedProfile(getDocumentPath("profile_image"));
          }
          if(getDocumentPath("aadhaar")){
            setFetchedAadhaar(getDocumentPath("aadhaar"));
          }

        

      } catch (error) {
        console.error("Error fetching userdetails:", error);
      }
    };
  
    // Fetch cities, and sports on initial render
    useEffect(() => {
      fetchDistricts();
      fetchSports();
      fetchUserDetails();
    }, []);

  function fieldName(field) {
    switch (field) {
      case "name":
        return "Player's Name";
      case "father_name":
        return "Father's Name";
      case "dob":
        return "Date of Birth";
      case "gender":
        return "Gender";
      case "email":
        return "Email ID";
      case "contact":
        return "Contact Number";
      case "aadhar":
        return "Aadhar Number";
      case "address":
        return "Full Address";
      case "district":
        return "District";
      case "pincode":
        return "Pincode";
      case "sport_category_senior_junior":
        return "Sport Category";
      case "sport_category_team_ind":
        return "Sport Category";
      case "association_name":
        return "Association Name";
      case "competition_start_date":
        return "Competition Start Date";
      case "competition_end_date":
        return "Competition End Date";
      case "number_of_players":
        return "Number of Players";
      case "player_bank_account_number":
        return "Bank Account Number";
      case "player_ifsc_code":
        return "IFSC Code";
      case "player_bank_name":
        return "Bank Name";
      case "player_bank_branch":
        return "Bank Branch";
      case "coach_bank_account_number":
        return "Bank Account Number";
      case "coach_ifsc_code":
        return "IFSC Code";
      case "coach_bank_name":
        return "Bank Name";
      case "coach_bank_branch":
        return "Bank Branch";
      case "coach_name":
        return "Coach Name";
      case "coach_address":
        return "Address";
      case "coach_pincode":
        return "Pincode";
      case "coach_contact":
        return "Contact Number";
      case "rec_dep_name":
        return "Recommending Department Name";
      case "rec_dep_officer_name":
        return "Recommending Officer Name";
      case "rec_dep_address":
        return "Recommending Department Address";
      case "rec_dep_mobile":
        return "Recommending Officer Mobile";
      case "applicant_photo":
        return "Applicant's Photo";
      case "competition":
        return "Competition Name";
      case "sport":
        return "Sport";
      case "medal":
        return "Medal";
      case "training_certificate":
        return "Training Certificate";
      case "second_training_certificate":
        return "Training Certificate";
      case "third_training_certificate":
        return "Training Certificate";
      case "tournament_certificate":
        return "Tournament Certificate";
      case "stamp_paper_training":
        return "Stamp Paper Declaration";
      case "second_stamp_paper_training":
        return "Stamp Paper Declaration";
      case "third_stamp_paper_training":
        return "Stamp Paper Declaration";
      case "association_verification_form":
        return "Association Verification Form";
      case "sports_proof":
        return "Sports Proof";
      case "applicant_aadhaar":
        return "Aadhar Card";
      case "event":
        return "Event";
      default:
        return field;
    }
  }
  
  const validateFile = (file, type) => {
    if (!file) return false;
    const fileType = file.type;
    const fileSize = file.size;

    if (type === "photo") {
      return (["image/jpeg", "image/png"].includes(fileType) && fileSize <= MAX_PHOTO_SIZE);
    }

    return fileType === "application/pdf" && fileSize <= MAX_DOC_SIZE;
  };

  const handleFileChange = async (e, name, type) => {

    const file = e.target.files[0];
    const isValid = validateFile(file, type);
    // console.log(type, isValid);
    setErrors(prev => ({
      ...prev,
      [name]: isValid ? null : `Invalid ${fieldName(name)} file (${type === "photo" ? "jpeg/png < 2mb" : "pdf < 2mb"})`
    }));

    if(isValid){

      if (file) {
        let payload = {};
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = async () => {
              try {
                payload.document=file;
                payload.applicant_id=applicationId;
                payload.document_type=name;
                payload.scheme_id=schemeId;
                let res = await uploadSchemeDocument(payload);
                // console.log(res);
                if(res.data.success){
                  // console.log(res.data.data.applicant_id);
                  setFormData(prev => ({ ...prev, [name]: file }));
                  setApplicationId(res.data.data.applicant_id);
                }
              } catch (error) {
                console.log(error);
                if (inputRefs.current[name]) {
                  inputRefs.current[name].value = null;
                }
                // setFormData(prev => ({ ...prev, [name]: null }));
                toast.error("Error occured while uploading document!", {
                  position: "bottom-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            };

      
    }
    }else{
      // console.log("file",file);
      // if(file){
        // console.log(name);
        setFormData(prev => ({ ...prev, [name]: null }));
        if (inputRefs.current[name]) {
          inputRefs.current[name].value = null;
        }
      // }
    }
  };

  const handleSelectChange = (e, name) => {
    setFormData({ ...formData, [name]: e.target.value });
    setErrors(prev => ({ ...prev, [name]: null }));
  };

  const submitForm=async()=>{
    setSubmitLoading(true);
    formData.applicant_id=applicationId;
    formData.scheme_id=schemeId;
    let res = await applyForScheme(formData);
    // console.log(res);
    if(res.data.success){
      setSubmitLoading(false);
      setFormData({"gender":"","district":"","sport":"","medal":"","competition":"","sport_category_senior_junior":"","sport_category_team_ind":""});
      setTimeout(() => {
        setModalOpen(true);
      }, 500);
    }else{
      setSubmitLoading(false);
      toast.error("Error occured while submitting form !", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
  

  const handleSubmit = (e) => {

    e.preventDefault();

    const requiredFields = [
      { name: "name" },
      { name: "father_name" },
      { name: "dob" },
      { name: "gender" },
      { name: "email" },
      { name: "address" },
      { name: "contact" },
      { name: "aadhar" },
      { name: "district" },
      { name: "pincode" },
      { name: "sport_category_senior_junior" },
      { name: "sport_category_team_ind" },
      { name: "association_name" },
      { name: "competition_start_date" },
      { name: "competition_end_date" },
      { name: "event" },
      { name: "player_bank_account_number" },
      { name: "player_ifsc_code" },
      { name: "player_bank_name" },
      { name: "player_bank_branch" },
      // { name: "coach_bank_account_number" },
      // { name: "coach_ifsc_code" },
      // { name: "coach_bank_name" },
      // { name: "coach_bank_branch" },
      // { name: "coach_name" },
      // { name: "coach_address" },
      // { name: "coach_pincode" },
      // { name: "coach_contact" },
      { name: "rec_dep_name" },
      { name: "rec_dep_officer_name" },
      { name: "rec_dep_address" },
      { name: "rec_dep_mobile" },
      // { name: "applicant_photo", type: "photo" },
      // { name: "applicant_aadhaar", type: "pdf" },
      { name: "competition" },
      { name: "sport" },
      { name: "medal" },
      // { name: "training_certificate", type: "pdf" },
      // { name: "second_training_certificate", type: "pdf" },
      // { name: "third_training_certificate", type: "pdf" },
      { name: "tournament_certificate", type: "pdf" },
      // { name: "stamp_paper_training", type: "pdf" },
      // { name: "second_stamp_paper_training", type: "pdf" },
      // { name: "third_stamp_paper_training", type: "pdf" },
      { name: "association_verification_form", type: "pdf" },
      { name: "sports_proof", type: "pdf" }
    ];

    const newErrors = {};

    requiredFields.forEach(({ name, type }) => {
      let value = formData[name];

      if (value && typeof value === "string") {
        value = value.trim();
      }

      if (!value) {
        newErrors[name] = `${fieldName(name)} is required`;
      } else if (type && !validateFile(value, type === "photo" ? "photo" : "pdf")) {
        newErrors[name] = `Invalid ${name} file (${type === "photo" ? "jpeg/png < 2mb" : "pdf < 2mb"})`;
      }
    });

    const aadhar = formData["aadhar"];
    const aadharRegex = /^(?!.*(\d)\1{11})([2-9]{1}[0-9]{11})$/;
    
    if (aadhar && !aadharRegex.test(aadhar)) {
      newErrors["aadhar"] = "Enter a valid 12-digit aadhar number";
    }
  
    // ✅ Custom validation for contact numbers
    const phoneRegex = /^[6-9]\d{9}$/; // Valid Indian mobile number
  
    if (formData["contact"] && !phoneRegex.test(formData["contact"])) {
      newErrors["contact"] = "Enter a valid 10-digit phone number";
    }

    const startDate = new Date(formData["competition_start_date"]);
    const endDate = new Date(formData["competition_end_date"]);

    if (startDate && endDate && endDate < startDate) {
      newErrors["competition_end_date"] = "End date is before start date";
    }
    
  
    // if (formData["coach_contact"] && !phoneRegex.test(formData["coach_contact"])) {
    //   newErrors["coach_contact"] = "Enter a valid 10-digit coach phone number";
    // }

    if (formData["rec_dep_mobile"] && !phoneRegex.test(formData["rec_dep_mobile"])) {
      newErrors["rec_dep_mobile"] = "Enter a valid 10-digit phone number";
    }
  
    // ✅ Conditional required field: number_of_players (only if team sport)
    if (formData["sport_category_team_ind"] === "2" && !formData["number_of_players"]) {
      newErrors["number_of_players"] = "Number of players is required";
    }else if(formData["sport_category_team_ind"] === "2" && formData["number_of_players"]<1){
      newErrors["number_of_players"] = "Number of players must be greater than or equal to 1";
    }


      // Pincode: must be 6-digit number
      let pincodeRegex=/^(?!0{6}$)\d{6}$/;
      const pincodeFields = ["pincode"];
      pincodeFields.forEach(field => {
        const value = formData[field];
        if (value && !pincodeRegex.test(String(value))) {
          newErrors[field] = `${fieldName(field)} must be a valid 6-digit pincode`;
        }
      });

      // Bank account: must be 9 to 18-digit number
      let bankAccountRegex=/^(?!0+$)\d{9,18}$/;
      const bankAccountFields = ["player_bank_account_number"];
      bankAccountFields.forEach(field => {
        const value = formData[field];
        if (value && !bankAccountRegex.test(String(value))) {
          newErrors[field] = `${fieldName(field)} must be valid`;
        }
      });

      // IFSE Code: must not be all zeroes
      let IFSECodeRegex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;
      const IFSECodeFields = ["player_ifsc_code"];
      IFSECodeFields.forEach(field => {
        const value = formData[field];
        if (value && !IFSECodeRegex.test(String(value))) {
          newErrors[field] = `${fieldName(field)} must be valid`;
        }
      });

      // Email: must match email regex
      if (formData["email"] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData["email"])) {
        newErrors["email"] = "Invalid email format";
      }

      // console.log(!formData["applicant_aadhaar"]);
      // console.log(!readOnlyFields.includes('aadhar'));
      // console.log("adhaar error", !formData["applicant_aadhaar"] && !readOnlyFields.includes('aadhar'));
      if (!formData["applicant_aadhaar"] && !readOnlyFields.includes('aadhar')) {
        // console.log("Aadhar Card is required");
        newErrors["applicant_aadhaar"] = "Aadhar Card is required";
      }

    // Coach Validations - apply only for opened coach sections
    const validateCoach = (prefix, displayPrefix) => {
    const contactField = `${prefix}_contact`;
    const pincodeField = `${prefix}_pincode`;
    const bankAccountField = `${prefix}_bank_account_number`;
    const ifscField = `${prefix}_ifsc_code`;

    const getTrimmedValue = (field) => (formData[field] || "").toString().trim();

    if (!getTrimmedValue(`${prefix}_name`)) {
      newErrors[`${prefix}_name`] = `${displayPrefix} Name is required`;
    }
    if (!getTrimmedValue(`${prefix}_address`)) {
      newErrors[`${prefix}_address`] = `${displayPrefix} Address is required`;
    }

    const pincode = getTrimmedValue(pincodeField);
    if (!pincode || !pincodeRegex.test(pincode)) {
      newErrors[pincodeField] = `${displayPrefix} Pincode must be a valid 6-digit number`;
    }

    const contact = getTrimmedValue(contactField);
    if (!contact || !phoneRegex.test(contact)) {
      newErrors[contactField] = `${displayPrefix} Contact must be a valid 10-digit number`;
    }

    const bankAccount = getTrimmedValue(bankAccountField);
    if (!bankAccount || !bankAccountRegex.test(bankAccount)) {
      newErrors[bankAccountField] = `${displayPrefix} Bank Account Number is invalid`;
    }

    const ifsc = getTrimmedValue(ifscField);
    if (!ifsc || !IFSECodeRegex.test(ifsc)) {
      newErrors[ifscField] = `${displayPrefix} IFSC Code is invalid`;
    }

    if (!getTrimmedValue(`${prefix}_bank_name`)) {
      newErrors[`${prefix}_bank_name`] = `${displayPrefix} Bank Name is required`;
    }
    if (!getTrimmedValue(`${prefix}_bank_branch`)) {
      newErrors[`${prefix}_bank_branch`] = `${displayPrefix} Bank Branch is required`;
    }

      // coach documents validations
      const docFieldMap = {
        coach: ["training_certificate", "stamp_paper_training"],
        second_coach: ["second_training_certificate", "second_stamp_paper_training"],
        third_coach: ["third_training_certificate", "third_stamp_paper_training"]
      };

      const fieldsToCheck = docFieldMap[prefix] || [];
      fieldsToCheck.forEach(field => {
        const value = formData[field];
        if (!value) {
          newErrors[field] = `${fieldName(field)} is required`;
        } else if (!validateFile(value, "pdf")) {
          newErrors[field] = `Invalid ${field} file (pdf < 2mb)`;
        }
      });

  };


    // Validate only open coach sections
    if (coach1) validateCoach("coach", "Coach");
    if (coach2) validateCoach("second_coach", "Coach");
    if (coach3) validateCoach("third_coach", "Coach");

    setErrors(newErrors);

    

    if (Object.keys(newErrors).length === 0) {
      // console.log("Submitting form:", formData);
      if (!isDeclared) {
        alert("Please accept the declaration before submitting the form.");
        return;
      }
      submitForm();
    }

  };

  const numberOnlyFields = [
    "contact",
    "aadhar",
    "pincode",
    "player_bank_account_number",
    "coach_pincode",
    "coach_contact",
    "coach_bank_account_number",
    "rec_dep_mobile",
    "number_of_players",
  ];

  const handleChange = (e, name) => {
    let value = e.target.value;
  
    // If field should accept only numbers
    if (numberOnlyFields.includes(name)) {
      value = value.replace(/\D/g, ""); // Remove non-digit characters
    }
  
    setFormData({ ...formData, [name]: value });
    setErrors(prev => ({ ...prev, [name]: null }));
  };

  const handleAddCoach = () => {
    if(noOfCoaches==0){
      setCoach1(true);
    }
    if(noOfCoaches==1){
      setCoach2(true);
    }
    if(noOfCoaches==2){
      setCoach3(true);
    }
    setNoOfCoaches(noOfCoaches+1);
  }

  const removeCoach=(coachno)=>{
    if(coachno==1){
      setCoach1(false);
      setFormData({ ...formData, "coach_name": "", "coach_address": "", "coach_pincode": "", "coach_contact": "", "coach_bank_account_number": "","coach_ifsc_code": "","coach_bank_name": "","coach_bank_branch": "" });
      setErrors({...errors, "coach_name": "", "coach_address": "", "coach_pincode": "", "coach_contact": "", "coach_bank_account_number": "","coach_ifsc_code": "","coach_bank_name": "","coach_bank_branch": "","training_certificate": "","stamp_paper_training": ""});
    }
    if(coachno==2){
      setCoach2(false);
      setFormData({ ...formData, "second_coach_name": "", "second_coach_address": "", "second_coach_pincode": "", "second_coach_contact": "", "second_coach_bank_account_number": "","second_coach_ifsc_code": "","second_coach_bank_name": "","second_coach_bank_branch": "" });
      setErrors({...errors,  "second_coach_name": "", "second_coach_address": "", "second_coach_pincode": "", "second_coach_contact": "", "second_coach_bank_account_number": "","second_coach_ifsc_code": "","second_coach_bank_name": "","second_coach_bank_branch": "","second_training_certificate": "","second_stamp_paper_training": ""});
    }
    if(coachno==3){
      setCoach3(false);
      setFormData({ ...formData, "third_coach_name": "", "third_coach_address": "", "third_coach_pincode": "", "third_coach_contact": "", "third_coach_bank_account_number": "","third_coach_ifsc_code": "","third_coach_bank_name": "","third_coach_bank_branch": "" });
      setErrors({...errors, "third_coach_name": "", "third_coach_address": "", "third_coach_pincode": "", "third_coach_contact": "", "third_coach_bank_account_number": "","third_coach_ifsc_code": "","third_coach_bank_name": "","third_coach_bank_branch": "","third_training_certificate": "","third_stamp_paper_training": "" });
    }
    setNoOfCoaches(noOfCoaches-1);
  }

  return (
    <div className="relative scheme-form-container user-schemes-container">
      <div className="form-container">

        <div className="form-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        
        <div>
          <h1 className="form-title">Application for Cash Award Scheme</h1>
          {/* <Badge bg="" className='badge-primary light badge-lg rounded-pill'>Sports Department</Badge> */}
          <span className="badge mb-2 text-white"
              style={{
                  background: "linear-gradient(90deg, #7942D1 0%, #2A1647 100%)",
                  fontSize: "0.80rem",
                  padding: "0.5em 1.5em",
                  borderRadius: "16056.36px"
              }}>Sports Department</span>

        </div>

        </div>

        <form onSubmit={handleSubmit} className="form">

          <section className="">
            <h4 className="application-section-heading">General Information</h4>
            <div className="form-inline-group">
              <Input label="Player's Name" required={true} placeholder="Enter Player's Name" name="name" value={formData.name} onChange={(e) => handleChange(e, "name")} error={errors.name} isReadOnly={true} />
              <Input label="Father's Name" required={true} placeholder="Enter Father's Name" name="father_name" value={formData.father_name} onChange={(e) => handleChange(e, "father_name")} error={errors.father_name} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <DatePickerField id="dob" label="Date of Birth (D.O.B)" required={true} placeholder="Enter Date of Birth" value={formData.dob} name="dob" type="date" onChange={(e) => handleChange(e, "dob")}  error={errors.dob} isReadOnly={true}/>
              <Select label="Gender" required={true} placeholder="Select Gender" options={genderList} value={formData.gender}  onChange={(e) => handleSelectChange(e, "gender")} error={errors.gender} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Input label="Email ID" required={true} placeholder="Enter Email ID" name="email" value={formData.email} onChange={(e) => handleChange(e, "email")} error={errors.email} isReadOnly={true}/>
              <Input label="Contact Number" required={true} placeholder="Enter Contact Number" name="contact"  value={formData.contact} maxLength={10} inputMode="numeric" onChange={(e) => handleChange(e, "contact")} error={errors.contact} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Input label="Aadhar Number" required={true} placeholder="Enter Aadhar Number" name="aadhar" maxLength={12} inputMode="numeric" value={formData.aadhar} onChange={(e) => handleChange(e, "aadhar")} error={errors.aadhar} isReadOnly={readOnlyFields.includes('aadhar')} />
              <Input label="Full Address" required={true} placeholder="Enter Full Address" name="address" value={formData.address} onChange={(e) => handleChange(e, "address")} error={errors.address} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Select label="District" required={true} placeholder="Select District" options={districtList} value={formData.district}  onChange={(e) => handleSelectChange(e, "district")} error={errors.district} isReadOnly={readOnlyFields.includes('district')} />
              <Input label="Pincode" required={true} placeholder="Enter Pincode" name="pincode" inputMode="numeric" value={formData.pincode} maxLength={6} onChange={(e) => handleChange(e, "pincode")} error={errors.pincode} isReadOnly={true}/>
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">Sport and Competition Details</h4>
            <div className="form-inline-group">
              <Select label="Name of the Sport" required={true} placeholder="Select Name of the Sport" options={sportList} value={formData.sport}  onChange={(e) => handleSelectChange(e, "sport")} error={errors.sport}/>
              <Select label="Name of the Competition" required={true} placeholder="Select Name of the Competition" options={competetionTypes} value={formData.competition} onChange={(e) => handleSelectChange(e, "competition")} error={errors.competition}/>
            </div>
            <div className="form-inline-group">
              <Input label="Name of the Event"  required={true} placeholder="Enter Event Name" name="event" onChange={(e) => handleChange(e, "event")} error={errors.event}/>
              <Select label="Medal(s) Received" required={true} placeholder="Select Medal" options={medalList} value={formData.medal}  onChange={(e) => handleSelectChange(e, "medal")} error={errors.medal}/>
            </div>
            <div className="form-inline-group">
              <Select label="Category" required={true} placeholder="Select Sport Category" options={sportCategoryList} value={formData.sport_category_senior_junior}  onChange={(e) => handleSelectChange(e, "sport_category_senior_junior")} error={errors.sport_category_senior_junior}/>
              <Input label="Association through which participated in the competition"  required={true} placeholder="Enter Name of the Association" name="association_name" onChange={(e) => handleChange(e, "association_name")} error={errors.association_name}/>
            </div>
            <div className="form-inline-group">
              <DatePickerField id="competition_start_date" label="Competition Start Date"  required={true} placeholder="Select Competition Start Date" value={formData.competition_start_date} onChange={(e) => handleChange(e, "competition_start_date")}  error={errors.competition_start_date} />
              {/* <Input label="Competition Start Date*" placeholder="Select Competition Start Date" name="competition_start_date" type="date" onChange={(e) => handleChange(e, "competition_start_date")}  error={errors.competition_start_date}/> */}
              <DatePickerField id="competition_end_date" label="Competition End Date"  required={true} placeholder="Select Competition End Date" name="competition_end_date" type="date" value={formData.competition_end_date} onChange={(e) => handleChange(e, "competition_end_date")}  error={errors.competition_end_date}/>
            </div>
            <div className="form-inline-group">
              <Select label="Team/Individual"  required={true} placeholder="Select Sport Category" options={sportCategoryTeamIndList} value={formData.sport_category_team_ind}  onChange={(e) => handleSelectChange(e, "sport_category_team_ind")} error={errors.sport_category_team_ind}/>
              {formData.sport_category_team_ind=="2" ? (
              <Input label="Total Number of Player in Team"  required={true} placeholder="Enter Number of player" name="number_of_players" value={formData.number_of_players} inputMode="numeric" maxLength={2} onChange={(e) => handleChange(e, "number_of_players")} error={errors.number_of_players}/>
              ):(
                <div className="mb-3"></div>
              )}
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">Applicant’s Bank Details</h4>
            <div className="form-inline-group">
              <Input label="Bank Account Number" required={true} placeholder="Enter Bank Account Number" inputMode="numeric" value={formData.player_bank_account_number} maxLength={18} name="player_bank_account_number" onChange={(e) => handleChange(e, "player_bank_account_number")} error={errors.player_bank_account_number} isReadOnly={readOnlyFields.includes('player_bank_account_number')}/>
              <Input label="IFSC Code"  required={true} placeholder="Enter IFSC Code" name="player_ifsc_code" maxLength={11} value={formData.player_ifsc_code} onChange={(e) => handleChange(e, "player_ifsc_code")} error={errors.player_ifsc_code} isReadOnly={readOnlyFields.includes('player_ifsc_code')}/>
            </div>
            <div className="form-inline-group">
              <Input label="Bank Name"  required={true} placeholder="Enter Bank Name" name="player_bank_name" value={formData.player_bank_name} onChange={(e) => handleChange(e, "player_bank_name")} error={errors.player_bank_name} isReadOnly={readOnlyFields.includes('player_bank_name')}/>
              <Input label="Bank Branch Name"  required={true} placeholder="Enter Bank Branch" name="player_bank_branch" value={formData.player_bank_branch} onChange={(e) => handleChange(e, "player_bank_branch")} error={errors.player_bank_branch} isReadOnly={readOnlyFields.includes('player_bank_branch')}/>
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">Details of Recommendation of Department/ Institution or Recognized State Sports Association</h4>
            <div className="form-inline-group">
              <Input label="Name of Department / Institution / State Sports Association" required={true} placeholder="Enter Department / Institution / State Sports Association" name="rec_dep_name" onChange={(e) => handleChange(e, "rec_dep_name")} error={errors.rec_dep_name}/>
              <Input label="Name of Officer" required={true} placeholder="Enter Name of Officer" name="rec_dep_officer_name" onChange={(e) => handleChange(e, "rec_dep_officer_name")} error={errors.rec_dep_officer_name}/>
            </div>
            <div className="form-inline-group">
              <Input label="Full Address" required={true} placeholder="Enter Full Address" name="rec_dep_address" onChange={(e) => handleChange(e, "rec_dep_address")} error={errors.rec_dep_address}/>
              <Input label="Mobile Number" required={true} placeholder="Enter Mobile Number" inputMode="numeric" value={formData.rec_dep_mobile} maxLength={10} name="rec_dep_mobile" onChange={(e) => handleChange(e, "rec_dep_mobile")} error={errors.rec_dep_mobile}/>
            </div>

          </section>
        {coach1 && <div className="card">
              <div className="card-header">
                <h4 className="application-section-heading">Coach & their Bank Details</h4>
                <small className="coach-details-remove" onClick={()=>{removeCoach(1)}}>{noOfCoaches==1?"Remove":""}</small>
              </div>
              <div className="card-body">
          <section className="">
            <div className="form-inline-group">
              <Input label="Name of Coach"  required={true} placeholder="Enter Name of Coach" name="coach_name" onChange={(e) => handleChange(e, "coach_name")} error={errors.coach_name}/>
              <Input label="Full Address"  required={true} placeholder="Enter Full Address" name="coach_address" onChange={(e) => handleChange(e, "coach_address")} error={errors.coach_address}/>
            </div>
            <div className="form-inline-group">
              <Input label="Pincode"  required={true} placeholder="Enter Pincode" name="coach_pincode" maxLength={6} inputMode="numeric" value={formData.coach_pincode} onChange={(e) => handleChange(e, "coach_pincode")} error={errors.coach_pincode}/>
              <Input label="Contact Number"  required={true} placeholder="Enter Contact Number" inputMode="numeric" value={formData.coach_contact} maxLength={10} name="coach_contact" onChange={(e) => handleChange(e, "coach_contact")} error={errors.coach_contact}/>
            </div>

            <hr class="custom-line" />

            <div className="form-inline-group">
              <Input label="Bank Account Number" required={true} placeholder="Enter Bank Account Number" maxLength={18} inputMode="numeric" value={formData.coach_bank_account_number} name="coach_bank_account_number" onChange={(e) => handleChange(e, "coach_bank_account_number")} error={errors.coach_bank_account_number}/>
              <Input label="IFSC Code" required={true} placeholder="Enter IFSC Code" maxLength={11} name="coach_ifsc_code" onChange={(e) => handleChange(e, "coach_ifsc_code")} error={errors.coach_ifsc_code}/>
            </div>
            <div className="form-inline-group">
              <Input label="Bank Name" required={true} placeholder="Enter Bank Name" name="coach_bank_name" onChange={(e) => handleChange(e, "coach_bank_name")} error={errors.coach_bank_name}/>
              <Input label="Bank Branch Name" required={true} placeholder="Enter Bank Branch" name="coach_bank_branch" onChange={(e) => handleChange(e, "coach_bank_branch")} error={errors.coach_bank_branch}/>
            </div>

            <hr class="custom-line" />

            <div className="form-inline-group">
              <Input label="Enclose 1 year sport diploma for the coach or equivalent or 6 week certificate or certificate of training of the national federation of the concerned sport(for Coach)" type="file" onChange={(e) => handleFileChange(e, "training_certificate", "pdf")} accept="application/pdf" error={errors.training_certificate} required={true} ref={(el) => (inputRefs.current["training_certificate"] = el)} />
              <Input label="Details related to the training of the instructor on a stamp paper of Rs.10(by player)" required={true} type="file" onChange={(e) => handleFileChange(e, "stamp_paper_training", "pdf")} accept="application/pdf" error={errors.stamp_paper_training} ref={(el) => (inputRefs.current["stamp_paper_training"] = el)}/>
            </div>
          </section>
          </div>
          </div>}
          {coach2 && <div className="card">
              <div className="card-header">
                <h4 className="application-section-heading">Coach & their Bank Details</h4>
                <small className="coach-details-remove" onClick={()=>{removeCoach(2)}}>{noOfCoaches==2?"Remove":""}</small>
              </div>
              <div className="card-body">
            <section className="">
              <div className="form-inline-group">
                <Input label="Name of Coach"  required={true} placeholder="Enter Name of Coach" name="second_coach_name" onChange={(e) => handleChange(e, "second_coach_name")} error={errors.second_coach_name}/>
                <Input label="Full Address"  required={true} placeholder="Enter Full Address" name="second_coach_address" onChange={(e) => handleChange(e, "second_coach_address")} error={errors.second_coach_address}/>
              </div>
              <div className="form-inline-group">
                <Input label="Pincode"  required={true} placeholder="Enter Pincode" name="second_coach_pincode" maxLength={6} inputMode="numeric" value={formData.second_coach_pincode} onChange={(e) => handleChange(e, "second_coach_pincode")} error={errors.second_coach_pincode}/>
                <Input label="Contact Number"  required={true} placeholder="Enter Contact Number" inputMode="numeric" value={formData.second_coach_contact} maxLength={10} name="second_coach_contact" onChange={(e) => handleChange(e, "second_coach_contact")} error={errors.second_coach_contact}/>
              </div>
              <hr class="custom-line" />
              <div className="form-inline-group">
                <Input label="Bank Account Number" required={true} placeholder="Enter Bank Account Number" maxLength={18} inputMode="numeric" value={formData.second_coach_bank_account_number} name="second_coach_bank_account_number" onChange={(e) => handleChange(e, "second_coach_bank_account_number")} error={errors.second_coach_bank_account_number}/>
                <Input label="IFSC Code" required={true} placeholder="Enter IFSC Code" maxLength={11} name="second_coach_ifsc_code" onChange={(e) => handleChange(e, "second_coach_ifsc_code")} error={errors.second_coach_ifsc_code}/>
              </div>
              <div className="form-inline-group">
                <Input label="Bank Name" required={true} placeholder="Enter Bank Name" name="second_coach_bank_name" onChange={(e) => handleChange(e, "second_coach_bank_name")} error={errors.second_coach_bank_name}/>
                <Input label="Bank Branch Name" required={true} placeholder="Enter Bank Branch" name="second_coach_bank_branch" onChange={(e) => handleChange(e, "second_coach_bank_branch")} error={errors.second_coach_bank_branch}/>
              </div>
              <hr class="custom-line" />
              <div className="form-inline-group">
                <Input label="Enclose 1 year sport diploma for the coach or equivalent or 6 week certificate or certificate of training of the national federation of the concerned sport(for Coach)" type="file" onChange={(e) => handleFileChange(e, "second_training_certificate", "pdf")} accept="application/pdf" error={errors.second_training_certificate} required={true} ref={(el) => (inputRefs.current["second_training_certificate"] = el)} />
                <Input label="Details related to the training of the instructor on a stamp paper of Rs.10(by player)" required={true} type="file" onChange={(e) => handleFileChange(e, "second_stamp_paper_training", "pdf")} accept="application/pdf" error={errors.second_stamp_paper_training} ref={(el) => (inputRefs.current["second_stamp_paper_training"] = el)}/>
              </div>
            </section>
          </div>
          </div>}
          {coach3 && <div className="card">
              <div className="card-header">
                <h4 className="application-section-heading">Coach & their Bank Details</h4>
                <small className="coach-details-remove" onClick={()=>{removeCoach(3)}}>{noOfCoaches==3?"Remove":""}</small>
              </div>
              <div className="card-body">
                <section className="">
                  <div className="form-inline-group">
                    <Input label="Name of Coach"  required={true} placeholder="Enter Name of Coach" name="third_coach_name" onChange={(e) => handleChange(e, "third_coach_name")} error={errors.third_coach_name}/>
                    <Input label="Full Address"  required={true} placeholder="Enter Full Address" name="third_coach_address" onChange={(e) => handleChange(e, "third_coach_address")} error={errors.third_coach_address}/>
                  </div>
                  <div className="form-inline-group">
                    <Input label="Pincode"  required={true} placeholder="Enter Pincode" name="third_coach_pincode" maxLength={6} inputMode="numeric" value={formData.third_coach_pincode} onChange={(e) => handleChange(e, "third_coach_pincode")} error={errors.third_coach_pincode}/>
                    <Input label="Contact Number"  required={true} placeholder="Enter Contact Number" inputMode="numeric" value={formData.third_coach_contact} maxLength={10} name="third_coach_contact" onChange={(e) => handleChange(e, "third_coach_contact")} error={errors.third_coach_contact}/>
                  </div>
                  <hr class="custom-line" />
                  <div className="form-inline-group">
                    <Input label="Bank Account Number" required={true} placeholder="Enter Bank Account Number" maxLength={18} inputMode="numeric" value={formData.third_coach_bank_account_number} name="third_coach_bank_account_number" onChange={(e) => handleChange(e, "third_coach_bank_account_number")} error={errors.third_coach_bank_account_number}/>
                    <Input label="IFSC Code" required={true} placeholder="Enter IFSC Code" maxLength={11} name="third_coach_ifsc_code" onChange={(e) => handleChange(e, "third_coach_ifsc_code")} error={errors.third_coach_ifsc_code}/>
                  </div>
                  <div className="form-inline-group">
                    <Input label="Bank Name" required={true} placeholder="Enter Bank Name" name="third_coach_bank_name" onChange={(e) => handleChange(e, "third_coach_bank_name")} error={errors.third_coach_bank_name}/>
                    <Input label="Bank Branch Name" required={true} placeholder="Enter Bank Branch" name="third_coach_bank_branch" onChange={(e) => handleChange(e, "third_coach_bank_branch")} error={errors.third_coach_bank_branch}/>
                  </div>
                  <hr class="custom-line" />
                  <div className="form-inline-group">
                    <Input label="Enclose 1 year sport diploma for the coach or equivalent or 6 week certificate or certificate of training of the national federation of the concerned sport(for Coach)" type="file" onChange={(e) => handleFileChange(e, "third_training_certificate", "pdf")} accept="application/pdf" error={errors.third_training_certificate} required={true} ref={(el) => (inputRefs.current["third_training_certificate"] = el)} />
                    <Input label="Details related to the training of the instructor on a stamp paper of Rs.10(by player)" required={true} type="file" onChange={(e) => handleFileChange(e, "third_stamp_paper_training", "pdf")} accept="application/pdf" error={errors.third_stamp_paper_training} ref={(el) => (inputRefs.current["third_stamp_paper_training"] = el)}/>
                  </div>
                </section>
              </div>
          </div>}

          {noOfCoaches<3 && <div className="add-coach-button">
              <span style={{ display: 'inline-flex', alignItems: 'center' }} onClick={handleAddCoach}>
              {noOfCoaches<1 ? "Add Coach Details":"Add More"}
            </span>
          </div>}

          

          <div className="card">
              <div className="card-header">
                <h4 className="card-title">Upload Documents</h4>
                <small className="card-subtitle">*Documents  should have size less than 2MB</small>
              </div>
              <div className="card-body">

                  <div className="">
                      <div className="form-inline-group">
                        <Input label="Sports Proof/evidence of participation from Uttrakhand" required={true} type="file" onChange={(e) => handleFileChange(e, "sports_proof", "pdf")} accept="application/pdf" error={errors.sports_proof} ref={(el) => (inputRefs.current["sports_proof"] = el)}/>
                        {fetchedProfile?<ViewDocument label="Upload Applicant's Photo" required={true} filepath={alreadyUploadedDocUrl+fetchedProfile} placeholder="View Photo"/>
                        :<Input label="Upload Applicant's Photo" type="file" id="formFile" onChange={(e) => handleFileChange(e, "applicant_photo", "photo")}
                            accept=".jpg, .jpeg, .png" error={errors.applicant_photo} required={true} ref={(el) => (inputRefs.current["applicant_photo"] = el)}/>}
                      </div>
                      <div className="form-inline-group">
                        <Input label="Related Tournament Certificate" required={true} type="file" onChange={(e) => handleFileChange(e, "tournament_certificate", "pdf")} accept="application/pdf" error={errors.tournament_certificate} ref={(el) => (inputRefs.current["tournament_certificate"] = el)}/>
                        <Input label="Association Verification Form" required={true} type="file" onChange={(e) => handleFileChange(e, "association_verification_form", "pdf")} accept="application/pdf" error={errors.association_verification_form} ref={(el) => (inputRefs.current["association_verification_form"] = el)}/>
                      </div>
                      <div className="form-inline-group">
                        {readOnlyFields.includes('aadhar')?<ViewDocument label="Aadhaar Card" required={true} filepath={alreadyUploadedDocUrl+fetchedAadhaar} placeholder="View Aadhaar"/>
                        :<Input label="Aadhaar Card" required={true} type="file" onChange={(e) => handleFileChange(e, "applicant_aadhaar", "pdf")} accept="application/pdf" error={errors.applicant_aadhaar} ref={(el) => (inputRefs.current["applicant_aadhaar"] = el)}/>}
                        <Input label="Any Other Documents (Optional)" type="file" onChange={(e) => handleFileChange(e, "other_doc", "pdf")} accept="application/pdf" error={errors.other_doc} ref={(el) => (inputRefs.current["other_doc"] = el)}/>
                      </div>
                  </div>
              </div>
          </div>

          <div className="declaration-section" style={{ margin: "0rem 0", display: "flex", alignItems: "flex-start" }}>
            <input
              type="checkbox"
              id="declaration"
              name="declaration"
              checked={isDeclared}
              onChange={(e) => setIsDeclared(e.target.checked)}
              style={{ marginTop: "4px", marginRight: "8px" }}
            />
            <label htmlFor="declaration" style={{ fontSize: "0.9rem", color: "#555" }}>
              I hereby declare that all the information provided in the application is true and correct in every respect
              and if any information is found to be incorrect the application shall be liable to be rejected. <span style={{ color: "red" }}>*</span>
            </label>
          </div>

          <div className="form-submit">
            <button type="submit" disabled={submitLoading}>
              <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              Submit Form
              {submitLoading && <span className="spinner"></span>}
            </span>
            </button>
          </div>
        </form>

      </div>
      
      {modalOpen && (
        <Modal icon={green_check} message="Your grant schemes and scholarship form has been successfully submitted." onSubmit={() => {setModalOpen(false); navigate(`/grant-scheme`);}} buttonText="Continue to Dashboard" appId={applicationId}/>
      )}

    </div>
  );
};

export default SchemeForm;
